import { render } from "./LearningGoals.vue?vue&type=template&id=c1832442"
import script from "./LearningGoals.vue?vue&type=script&lang=js"
export * from "./LearningGoals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__